import './utils/getOwnPropertyNames';
import 'promise-polyfill/src/polyfill';
import 'string.prototype.startswith';
import 'es7-object-polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

require('array.prototype.find').shim();
